<script setup lang="ts">
import { defineProps, computed } from "vue";
const props = defineProps<{
  modelValue: string[] | number[]
  items: {
    "F": string
    "R": string
    "I": string
    "S": string
  }
  selectableItems: any
  disabled: boolean
}>()

const emit = defineEmits(["update:modelValue"])
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})
</script>
<template>
  <template v-for="(item, key) in props.items" :key="key">
    <v-checkbox
      v-model="modelValue"
      :value="key"
      :label="item"
      :disabled="!props.selectableItems.includes(key) || props.disabled"
      density="compact"
    />
  </template>
</template>
